import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        property: null,
        photos: null,
        epcs: null,
        floorPlans: null,
        brochures: null,
    },

    getters: {
        getField,
        hasPhotos: (state) => {
            return (state.photos && state.photos.length);
        },
        hasEpcs: (state) => {
            return (state.epcs && state.epcs.length);
        },
        hasFloorPlans: (state) => {
            return (state.floorPlans && state.floorPlans.length);
        },
        hasBrochures: (state) => {
            return (state.brochures && state.brochures.length);
        },
        photosCarousel: (state) => {
            if(! state.photos) {
                return [];
            }
            return state.photos.map((row) => {
                return {
                    title: row.Description,
                    image: `/contacts/vendor/properties/${state.property.PropertyPK}/photos/${row.PropertyPhotoPK}`,
                };
            });
        },
        epcsCarousel: (state) => {
            if(! state.epcs) {
                return [];
            }
            return state.epcs.map((row) => {
                return {
                    title: row.Description,
                    image: `/contacts/vendor/properties/${state.property.PropertyPK}/photos/${row.PropertyPhotoPK}`,
                };
            });
        },
        floorPlansCarousel: (state) => {
            if(! state.floorPlans) {
                return [];
            }
            return state.floorPlans.map((row) => {
                return {
                    title: row.Description,
                    image: `/contacts/vendor/properties/${state.property.PropertyPK}/photos/${row.PropertyPhotoPK}`,
                };
            });
        },
    },

    actions: {
        reset({ commit }) {
            commit('setProperty', null);
            commit('setPhotos', null);
            commit('setEpcs', null);
            commit('setFloorPlans', null);
            commit('getBrochures', null);
        },
        getRow({ commit }, propertyPK) {
            return axios.get(`/api/contacts/vendor/properties/${propertyPK}`)
            .then((response) => {
                commit('setProperty', response.data.data);
            })
            .catch(() => {
                commit('setProperty', {});
            });
        },
        getPhotos({ commit }, propertyPK) {
            return axios.get(`/api/contacts/vendor/properties/${propertyPK}/photos`)
            .then((response) => {
                commit('setPhotos', response.data.data);
            })
            .catch(() => {
                commit('setPhotos', []);
            });
        },
        getEpcs({ commit }, propertyPK) {
            return axios.get(`/api/contacts/vendor/properties/${propertyPK}/epcs`)
            .then((response) => {
                commit('setEpcs', response.data.data);
            })
            .catch(() => {
                commit('setEpcs', []);
            });
        },
        getFloorPlans({ commit }, propertyPK) {
            return axios.get(`/api/contacts/vendor/properties/${propertyPK}/floor-plans`)
            .then((response) => {
                commit('setFloorPlans', response.data.data);
            })
            .catch(() => {
                commit('setFloorPlans', []);
            });
        },
        getBrochures({ commit }, propertyPK) {
            return axios.get(`/api/contacts/vendor/properties/${propertyPK}/brochures`)
            .then((response) => {
                commit('setBrochures', response.data.data);
            })
            .catch(() => {
                commit('setBrochures', []);
            });
        },
    },

    mutations: {
        updateField,
        setProperty(state, property) {
            state.property = property;
        },
        setPhotos(state, photos) {
            state.photos = photos;
        },
        setEpcs(state, epcs) {
            state.epcs = epcs;
        },
        setFloorPlans(state, floorPlans) {
            state.floorPlans = floorPlans;
        },
        setBrochures(state, brochures) {
            state.brochures = brochures;
        },
    },
};
